export const assertNever = (argument: never, errorMessage: string): never => {
    throw new Error(errorMessage)
}
